// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const colors = {
  veloWhite: 'rgba(255, 255, 255, 1)',
  veloGrey1: 'rgba(250, 250, 250, 1)',
  veloGrey2: 'rgba(224, 224, 224, 1)',
  veloGrey3: 'rgba(244, 245, 239, 1)',
  veloGrey4: 'rgba(196, 198, 193, 1)',
  veloMainBlue: 'rgba(0, 69, 112, 1)',
  veloPeach: 'rgba(254, 140, 117, 1)',
  veloDarkBlue: 'rgba(8, 25, 48, 1)',
  veloRiderShift10: 'rgba(241, 250, 249, 1)',
  veloShiftBlue10: 'rgba(241, 242, 255, 1)',
  veloPeach10: 'rgba(255, 244, 241, 1)',
  veloShiftBlue: 'rgba(111, 125, 255, 1)',
  veloBlueGrey: 'rgba(106, 115, 129, 1)',
  systemBlue: 'rgba(39, 61, 255, 1)',
  systemGreen: 'rgba(63, 208, 104, 1)',
  systemWarning: 'rgba(255, 30, 30, 1)',
  systemYellow: 'rgba(255, 229, 0, 1)',
  systemBlueLight: 'rgba(173, 176, 202, 1)',
  systemBlue50: 'rgba(147, 158, 255, 1)',
  systemGreen50: 'rgba(159, 231, 179, 1)',
  systemWarning50: 'rgba(255, 142, 142, 1)',
  systemBlueLight50: 'rgba(214, 215, 228, 1)',
  systemYellow50: 'rgba(255, 242, 128, 1)',
  veloMainBlueHover: 'rgba(0, 55, 89, 1)',
  veloPeachHover: 'rgba(225, 134, 115, 1)',
  veloDarkBlueHover: 'rgba(55, 60, 67, 1)',
  veloShiftBlueHover: 'rgba(99, 112, 221, 1)',
  systemBlueHover: 'rgba(99, 112, 221, 1)',
  systemGreenHover: 'rgba(69, 222, 113, 1)',
  systemWarningHover: 'rgba(239, 18, 18, 1)',
  riderShift: 'rgba(112, 207, 190, 1)',
  managerShift: 'rgba(211, 169, 242, 1)',
  maintenanceShift: 'rgba(254, 115, 165, 1)',
  instructorShift: 'rgba(128, 107, 221, 1)',
  trainingShift: 'rgba(74, 175, 232, 1)',
  buddyShift: 'rgba(207, 150, 154, 1)',
  otherShift: 'rgba(255, 191, 115, 1)',
  productivityBlue: 'rgba(107, 75, 246, 1)',
  productivityBackground: 'rgba(248, 246, 255, 1)',
  productivityPurple: 'rgba(99, 40, 224, 1)'
} as const;

export default colors;
